export const PORTAL_IDS = Object.freeze({
  SUPPORT: 'support',
  MENTOR: 'mentor',
  CLINIC: 'clinic',
  CLINIC_ASSISTANT: 'clinic-assistant',
  IPD: 'ipd',
  KIOSK: 'kiosk',
  DISPLAY: 'display',
  BUSINESS: 'business',
  PATIENT: 'patient',
  PATIENT_PROSPECT: 'patient-prospect',
  CONSUMER: 'consumer',
  CONTROL_CENTER: 'control-center',
})

export const PORTAL_CHOOSER_ID = 'portal-chooser'
